// removed by extract-text-webpack-plugin
module.exports = {"Bluecheese":"#615CFF","cta":"Gcab7b1","tooltip":"Gc4d3a7","cta__icon":"Ge33cef"};